exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._7A1i1L7pk1MaY_OCz4YLb{white-space:nowrap}html[dir] ._7A1i1L7pk1MaY_OCz4YLb{padding:5px 15px;margin:0}._3GtoDixJhibTv4EMhn98jH{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}", ""]);

// exports
exports.locals = {
	"toggle": "_7A1i1L7pk1MaY_OCz4YLb",
	"container": "_3GtoDixJhibTv4EMhn98jH"
};